import {map} from "rxjs/operators";

export function pluck<Type>(key: keyof Type) {
  return (element: Type) => element[key];
}

export function where<Type>(key: keyof Type, expected: any) {
  return (element: Type) => element[key] === expected;
}

export function flatMap<T, U>(array: T[], callbackfn: (value: T, index: number, array: T[]) => U[]): U[] {
  return Array.prototype.concat(...array.map(callbackfn));
}

export function filterCollection<Type>(predicate: (item: Type) => boolean) {
  return map((collection: Type[]) => collection.filter(predicate));
}
